module.exports = __webpack_public_path__ + "static/img/7725_phase_function_Paper_PointsHejduk_Prediction.14bb2ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7725_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Mr88
// module chunks = 0